<template>
  <div class="columns is-multiline">
    <div class="column is-4">
      <sc-field
        prop="status_pi"
        label="Status do PI"
      >
        <sc-select
          v-model="filters.status_pi"
          v-if="status_pi"
          placeholder="Selecione"
          expanded
        >
          <option :value="null">Selecione</option>
          <option
            :value="status.code"
            v-for="status in status_pi"
            :key="status.code"
          >{{status.description}}</option>
        </sc-select>
      </sc-field>
    </div>

    <div class="column is-4">
      <sc-field
        prop="sub_status_pi"
        label="Substatus do PI"
      >
        <sc-select
          v-model="filters.sub_status_pi"
          v-if="sub_status_pi"
          placeholder="Selecione"
          expanded
        >
          <option :value="null">Selecione</option>
          <option
            :value="sub_status.code"
            v-for="sub_status in sub_status_pi"
            :key="sub_status.code"
          >{{sub_status.description}}</option>
        </sc-select>
      </sc-field>
    </div>

    <div class="column is-4">
      <sc-field
        prop="condition"
        label="PI"
      >
        <sc-select
          v-model="filters.condition"
          placeholder="Selecione"
          expanded
        >
          <option :value="null">Selecione</option>
          <option value="WITHOUT_PI">Sem PI</option>
          <option value="WITH_PI">Com PI</option>
        </sc-select>
      </sc-field>
    </div>
    <div class="column ">
      <sc-field
        label="Data da criação"
        prop="date_range"
      >
        <sc-range-date-picker v-model="filters.date_range" />
      </sc-field>
    </div>

    <div class="column">
      <sc-field
        label="Prazo de resposta"
        prop="date_range_response"
      >
        <sc-range-date-picker v-model="filters.date_range_response" />
      </sc-field>
    </div>
  </div>

</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScField,
  ScRangeDatePicker,
  ScSelect,
} from '@intelipost-js/secure-components';

const { mapState } = createNamespacedHelpers('refund/export');
export default {
  name: 'filter-by-date',
  computed: {
    ...mapState([
      'status_pi',
      'sub_status_pi',
    ]),
  },
  props: {
    filters: {
      type: Object,
    },
    rules: {
      type: Object,
    },
  },
  components: {
    ScField,
    ScSelect,
    ScRangeDatePicker,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-refund/features/export-xls/components/FilterByDate.vue